import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  useFetchAuthorisation,
  authorisationConverter,
  useFetchUserData,
} from "../../utils/AppFunctions";
import config from "../../app-config";
import "react-toastify/dist/ReactToastify.css";
import AdminLayout from "../../layouts/AdminLayout";
import { approve_claim, create_new_claim, delete_claim, fetch_claim_by_id, fetch_claims_by_account_id, mark_claim_as_reimbursed, process_payment, reject_claim, update_claim } from "../../api/claimsAPI";
import notify from "../../utils/IANotification";
import ModalLayout from "../../layouts/ModalLayout";
import { fetch_all_users_admin } from "../../api/usersAPI";
import Select from "react-select"
import { fetch_all_accounts } from "../../api/accountsAPI";
import FileUploadField from "../../components/ui/FileUploadField";
import { MdDelete, MdDownload, MdOpenInNew } from "react-icons/md";

export default function ClaimsFormPage() {
  const navigate = useNavigate();
  let claims_id = new URLSearchParams(window.location.search).get("claims_id") || "new";
  const [deleteConfirmation, setDeleteConfirmation] = useState("")
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false)
  const [previewModalVisible, setPreviewModalVisible] = useState(false)
  const [previewFile, setPreviewFile] = useState(null)

  const [claimsData, setClaimsData] = useState({
    account_id: "",
    claim_type: "", // food, transport, accommodation, stationery, equipment, other
    category_id: "",
    user_id: "",
    description: "",
    claim_value: "",
    currency: "",
    currency_rate: "",
    claim_date: "",
    files: []
  })
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [accounts, setAccountData] = useState([])

  const fetchClaimsById = async () => {
    if (claims_id === "new") return
    let { data, message, error } = await fetch_claim_by_id(claims_id)
    if (error) return console.error(error)
    setClaimsData(data)
  }

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_accounts()
    if (error) return console.log("Error fetching accounts:", message)
    setAccountData(data)
    setLoading(false)
  }

  const fetchPlatformUsers = async () => {
    setLoading(true)
    const data = await fetch_all_users_admin()
    if (data?.status === 200) {
      setUsers(data.data)
    }
    setLoading(false)
  }


  useEffect(() => {
    fetchPlatformUsers()
    fetchClaimsById()
  }, [])

  const submitClaim = async () => {
    let formData = new FormData();
    for (let key in claimsData) {
      formData.append(key, claimsData[key]);
    }
    for (let i = 0; i < claimsData?.files.length; i++) {
      formData.append('files', claimsData?.files[i]);
    }
    if (claims_id !== "new") return
    let { data, message, error } = await create_new_claim(formData)
    if (error) return notify({ type: "error", message: `Error creating claim: ${message}` })
    navigate(`/admin/claims/details?claims_id=${data.id}`)
    notify({ type: "success", message: "Claim updated successfully" })
  }

  const updateClaim = async () => {
    if (claims_id === "new") return
    let formData = new FormData();
    for (let key in claimsData) {
      formData.append(key, claimsData[key]);
    }
    for (let i = 0; i < claimsData.files.length; i++) {
      formData.append('files', claimsData.files[i]);
    }
    let { data, message, error } = await update_claim(claims_id, formData)
    if (error) return notify({ type: "error", message: `Error creating claim: ${message}` })
    await fetchClaimsById()
    notify({ type: "success", message: "Claim updated successfully" })
  }

  const deleteClaim = async () => {
    if (claims_id === "new") return
    let { data, message, error } = await delete_claim(claims_id)
    if (error) return notify({ type: "error", message: `Error creating claim: ${message}` })
    navigate(`/admin/claims/`)
    notify({ type: "success", message: "Claim updated successfully" })
  }

  const approveClaim = async () => {
    if (claims_id === "new") return
    let { data, message, error } = await approve_claim(claims_id)
    if (error) return notify({ type: "error", message: `Error approving claim: ${message}` })
    await fetchClaimsById()
    notify({ type: "success", message: "Claim approved successfully" })
  }

  const rejectClaim = async () => {
    if (claims_id === "new") return
    let { data, message, error } = await reject_claim(claims_id)
    if (error) return notify({ type: "error", message: `Error rejecting claim: ${message}` })
    await fetchClaimsById()
    notify({ type: "success", message: "Claim rejected successfully" })
  }

  const processClaimPayment = async () => {
    if (claims_id === "new") return
    let { data, message, error } = await process_payment(claims_id)
    if (error) return notify({ type: "error", message: `Error processing claim payment: ${message}` })
    await fetchClaimsById()
    notify({ type: "success", message: "Claim payment processed successfully" })
  }

  const markClaimAsReimbursed = async () => {
    if (claims_id === "new") return
    let { data, message, error } = await mark_claim_as_reimbursed(claims_id)
    if (error) return notify({ type: "error", message: `Error marking claim as reimbursed: ${message}` })
    await fetchClaimsById()
    notify({ type: "success", message: "Claim marked as reimbursed successfully" })
  }






  return (
    <AdminLayout navSelected={"Claims"}
      toolbar={
        <>
          <h1 className="text-2xl font-bold text-gray-900">
            {claims_id === "new" ? "Create Claim" : "Edit Claim"}
          </h1>
          <div className="flex gap-2">
            {claims_id !== "new" && claimsData?.claim_status !== "approved" && claimsData?.claim_status !== "paid" && claimsData?.claim_status !== "rejected" && claimsData?.claim_status !== "process_payment" && (
              <button
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                onClick={() => setShowDeleteConfirmationModal(true)}
              >
                Delete
              </button>
            )}
            {(claimsData?.claim_status === "pending" || claimsData?.claim_status === "rejected") && (
              <>
                <button
                  className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                  onClick={() => {
                    approveClaim()
                  }}
                >
                  Approve
                </button>
                <button
                  className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors"
                  onClick={() => {
                    rejectClaim()
                  }}
                >
                  Reject
                </button>
              </>
            )}
            {claimsData?.claim_status === "approved" && (
              <button
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                onClick={() => {
                  processClaimPayment()
                }}
              >
                Process Payment
              </button>
            )}
            {claimsData?.claim_status === "process_payment" && (
              <button
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                onClick={() => {
                  markClaimAsReimbursed()
                }}
              >
                Mark as Reimbursed
              </button>
            )}
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              onClick={() => {
                if (claims_id === "new") {
                  submitClaim()
                } else {
                  updateClaim()
                }
              }}
            >
              {claims_id === "new" ? "Create" : "Save"}
            </button>
          </div>
        </>
      }
    >
      <ModalLayout modalTitle={`Delete Claim`}
        isVisible={showDeleteConfirmationModal} setIsVisible={setShowDeleteConfirmationModal}>
        <div className="flex-row flex justifyEnd">
          <button className="button-delete" onClick={() => {
            deleteClaim()
          }}>Delete</button>
        </div>
      </ModalLayout>
      <div className="flex flex-row gap-2">
        <div className="card">
          <p className="card-title">Claim Information</p>
          <div className="input-container">
            <label className="input-label">Description</label>
            <textarea className="textarea-input h-24" placeholder="e.g. Return flight for mission trip"
              disabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
              value={claimsData.description} onChange={(e) => setClaimsData({ ...claimsData, description: e.target.value })} />
          </div>

          <div className="input-container">
            <label className="input-label">Account</label>
            <Select
              value={accounts.find(account => account.id === claimsData.account_id) || null}
              onChange={(selectedOption) => {
                setClaimsData({ ...claimsData, account_id: selectedOption.id })
              }}
              getOptionLabel={(e) => `${e.name} (${e.description})`}
              getOptionValue={(e) => e.id}
              options={accounts}
              isDisabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
              placeholder="Select Account"
            />
          </div>

          <div className="input-container">
            <label className="input-label">Claim Type</label>
            <Select
              value={claimsData.claim_type ? { value: claimsData.claim_type, label: claimsData.claim_type.charAt(0).toUpperCase() + claimsData.claim_type.slice(1) } : null}
              onChange={(selectedOption) => {
                setClaimsData({ ...claimsData, claim_type: selectedOption.value })
              }}
              getOptionLabel={(e) => e.label}
              getOptionValue={(e) => e.value}
              options={[
                { value: "food", label: "Food" },
                { value: "transport", label: "Transport" },
                { value: "accommodation", label: "Accommodation" },
                { value: "stationery", label: "Stationery" },
                { value: "equipment", label: "Equipment" },
                { value: "other", label: "Other" },
              ]}
              isDisabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
              placeholder="Select Claim Type"
            />
          </div>

          <div className="input-container">
            <label className="input-label">Claimee</label>
            <Select
              value={users.find(user => user.id == claimsData.user_id) || null}
              onChange={(selectedOption) => {
                setClaimsData({ ...claimsData, user_id: selectedOption.id })
              }}
              getOptionLabel={(e) => `${e.first_name} ${e.last_name} (${e.email})`}
              getOptionValue={(e) => e.id}
              options={users}
              placeholder="Select User"
              isDisabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
            />
          </div>
          <div className="input-container">
            <label className="input-label">Claim Value in {claimsData.currency ? claimsData.currency.toUpperCase() : 'SGD'}</label>
            <input type="number"
              disabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
              className="text-input" placeholder="e.g. 100.00" value={claimsData.claim_value} onChange={(e) => setClaimsData({ ...claimsData, claim_value: e.target.value })} />
          </div>
          <div className="input-container">
            <label className="input-label">Currency</label>
            <Select
              value={accounts.find(account => account.id === claimsData.account_id)?.currency.find(c => c.currency === claimsData.currency) || null}
              onChange={(selectedOption) => {
                setClaimsData({ ...claimsData, currency: selectedOption.currency, currency_rate: selectedOption.rate })
              }}
              getOptionLabel={(e) => e.currency}
              getOptionValue={(e) => e.currency}
              options={accounts.find(account => account.id === claimsData.account_id)?.currency || []}
              placeholder="Select Currency"
              isDisabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
            />
          </div>
          <div className="input-container">
            <label className="input-label">Currency Rate</label>
            <input type="number" className="text-input"
              disabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
              placeholder="e.g. 1.35" value={claimsData.currency_rate} onChange={(e) => setClaimsData({ ...claimsData, currency_rate: e.target.value })} />
          </div>
          <div className="input-container">
            <label className="input-label">Claim Date</label>
            <input type="date" className="text-input"
              disabled={claimsData?.claim_status !== "pending" && claimsData?.claim_status !== "rejected" && claims_id !== "new"}
              placeholder="e.g. 2023-10-01" value={claimsData.claim_date} onChange={(e) => setClaimsData({ ...claimsData, claim_date: e.target.value })} />
          </div>
        </div>
        <div className="w-full">
          <div className="card">
            {(claimsData?.claim_status === "pending" || claimsData?.claim_status === "rejected") && <>
              <p className="card-title">Uploaded Media</p>
              <FileUploadField
                item_index={"1"}
                max_file_size={5}
                max_files={10}
                // background_image_url={null}
                onFileSelected={(files) => {
                  // Handle file selection and upload logic here
                  setClaimsData({ ...claimsData, files: files })
                }}
                onChange={() => { }}
              />
            </>
            }
          </div>
          <div className="card mt-2">
            <p className="card-title mb-2">Attached Media</p>
            <div className="flex flex-row flex-wrap gap-2">
              {claimsData.file_data && claimsData.file_data.length > 0 ? claimsData.file_data.map((file, index) => (
                <div key={index} className="w-32 h-32 border rounded-lg overflow-hidden relative">
                  {file?.ext_file_path?.toLowerCase().endsWith(".jpg") || file?.ext_file_path?.toLowerCase().endsWith(".png") || file?.ext_file_path?.toLowerCase().endsWith(".jpeg") ? (
                    <img
                      src={`${config.endpoint}${file?.ext_file_path}`}
                      alt={`Uploaded ${index + 1}`}
                      className="w-full h-full object-cover cursor-pointer"
                      onClick={() => { setPreviewFile(file); setPreviewModalVisible(true); }}
                    />
                  ) : file?.ext_file_path?.toLowerCase().endsWith('.pdf') ? (
                    <div className="w-full h-full flex items-center justify-center bg-gray-100 cursor-pointer" onClick={() => { setPreviewFile(file); setPreviewModalVisible(true); }}>
                      <div className="text-center">
                        <div className="font-semibold">PDF</div>
                        <div className="text-xs text-gray-500 truncate" style={{ maxWidth: 120 }}>{file?.file_name || file?.ext_file_path}</div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-100">
                      <a href={`${config.endpoint}${file?.ext_file_path}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                        View File
                      </a>
                    </div>
                  )}
                </div>
              )) : (<p>No files attached.</p>)}
            </div>
          </div>
        </div>
      </div>

      <ModalLayout modalTitle={previewFile ? (previewFile.file_name || 'Preview') : 'Preview'} isVisible={previewModalVisible} setIsVisible={setPreviewModalVisible}>
        {previewFile ? (
          <div className="flex flex-col gap-3 mt-4">
            <div className="flex gap-2 justify-end">
              <a href={`${config.endpoint}${previewFile.ext_file_path}`} target="_blank" rel="noopener noreferrer" className="px-3 py-1 rounded text-sm flex flex-row items-center gap-2">
                <MdOpenInNew size={16} />
                Open in new tab</a>
              <button className="px-3 py-1 text-black rounded text-sm flex flex-row items-center gap-2" onClick={() => {
                const url = `${config.endpoint}${previewFile.ext_file_path}`;
                const a = document.createElement('a');
                a.href = url;
                a.download = previewFile.file_name || url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }}>
                <MdDownload size={16} />
                Download</button>
              <button className="px-3 py-1 text-black rounded text-sm flex flex-row items-center gap-2" onClick={() => {
                // remove from file_data and media_assets_ids if present
                setClaimsData(prev => {
                  const nextFileData = (prev.file_data || []).filter(f => f.id !== previewFile.id);
                  const nextMediaIds = (prev.media_assets_ids || []).filter(id => id !== previewFile.id);
                  return { ...prev, file_data: nextFileData, media_assets_ids: nextMediaIds };
                });
                setPreviewModalVisible(false);
                setPreviewFile(null);
              }}>
                <MdDelete size={16} />
                Delete</button>
            </div>

            <div style={{ minHeight: 400 }} className="border rounded p-2 flex items-center justify-center">
              {previewFile.ext_file_path.toLowerCase().endsWith('.pdf') ? (
                <iframe src={`${config.endpoint}${previewFile.ext_file_path}`} title={previewFile.file_name || 'pdf-preview'} style={{ width: '100%', height: '80vh', border: 'none' }} />
              ) : (
                <img src={`${config.endpoint}${previewFile.ext_file_path}`} alt={previewFile.file_name || 'preview'} style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
              )}
            </div>
          </div>
        ) : (<div>No file selected</div>)}
      </ModalLayout>

      {/* <pre>{JSON.stringify(claimsData, null, 2)}</pre> */}
    </AdminLayout >
  )
}